import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import '@/i18n';
import { router } from '@/router';
import { queryClient } from '@/services/query-client';
import { OfflineBanner } from '@/components/OfflineBanner';
import { UpdatePrompt } from '@/components/UpdatePrompt';
import { CallScreen } from '@/components/call/CallScreen';
import { IncomingCallGuard } from '@/components/call/IncomingCallGuard';
import '@/styles/nav.css';
import '@/styles/layout.css';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <OfflineBanner />
      <RouterProvider router={router} />
      <UpdatePrompt />
      <IncomingCallGuard />
      <CallScreen />
      <Toaster
        position="top-center"
        richColors
        closeButton
        toastOptions={{ duration: 2500 }}
      />
    </QueryClientProvider>
  );
}
